import React, { useContext, createContext, useState, useCallback, useEffect } from 'react'
import { useApolloClient } from '@apollo/client'
import { CONFIGS } from 'query'
import { useClientUser } from 'contexts/ClientUserProvider'

const CommonContext = createContext(null)

const CommonProvider = ({ children }) => {
  const apolloClient = useApolloClient();
  const { isLoggedIn } = useClientUser();

  const [commonData, setCommonData] = useState([]);
  const [configLoading, setConfigLoading] = useState(false);

  const getConfigurations = useCallback(async () => {
    setConfigLoading('get-configurations');

    try {
      const result = await apolloClient.query({
        query: CONFIGS
      });

      const configs = result.data.configs.result;
      setCommonData(configs);
      return configs;
    } catch (err) {
      console.error("CommonProvider getConfigurations", err)
      throw err
    } finally {
      setConfigLoading('');
    }
  }, [apolloClient])

  useEffect(() => {
    if (isLoggedIn) {
      getConfigurations();
    }
  }, [isLoggedIn, getConfigurations]);

  const getOptionData = useCallback((name) => {
    return commonData.find(config => config.name === name).types || [];
  }, [commonData])

  return (
    <CommonContext.Provider
      value={{
        commonData,
        configLoading,
        getOptionData,
      }}
    >
      {children}
    </CommonContext.Provider>
  )
}

const useCommon = () => {
  const context = useContext(CommonContext)
  if (context == null) {
    throw new Error('useCommon() called outside of a CommonProvider?')
  }
  return context
}

export { CommonProvider, useCommon } 